
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/casino/[[...casino]]",
      function () {
        return require("private-next-pages/casino/[[...casino]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/casino/[[...casino]]"])
      });
    }
  